<mat-tab-group>
  <mat-tab label="Résumé">
    <div class="outer-trim">
      <div class="inner-trim">
        <div class="pdf-container">
          <pdf-viewer [render-text]="true"
                      [src]="resumeSrc"
                      [zoom]="mo.isActive('xs') || mo.isActive('sm') ? getPdfViewZoomLevel() : 1"
                      style="display: block;"
          ></pdf-viewer>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Profile">
    <div class="outer-trim">
      <div class="inner-trim">
        <div class="pdf-container">
          <pdf-viewer [render-text]="true"
                      [src]="descriptionSrc"
                      [zoom]="mo.isActive('xs') || mo.isActive('sm') ? getPdfViewZoomLevel() : 1"
                      style="display: block;"
          ></pdf-viewer>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Flow">
    <div class="outer-trim">
      <div class="inner-trim">
        <div class="pdf-container">
          <pdf-viewer [render-text]="true"
                      [src]="methodologySrc"
                      [zoom]="mo.isActive('xs') || mo.isActive('sm') ? getPdfViewZoomLevel() : 1"
                      style="display: block;"
          ></pdf-viewer>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Skills">
    <div class="outer-trim">
      <div class="inner-trim">
        <div class="pdf-container">
          <pdf-viewer [render-text]="true"
                      [src]="continuumSrc"
                      [zoom]="mo.isActive('xs') || mo.isActive('sm') ? getPdfViewZoomLevel() : 1"
                      style="display: block;"
          ></pdf-viewer>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
